import { useEffect, useMemo } from 'react';
import { PublicationsAndSalesDashboardProps } from '../../../../interfaces/components';
import styles from './publicationsAndSales.module.scss';
import Chart from "react-apexcharts";
import { useToast } from '../../../../helpers/hooks';

const PublicationsAndSales = ({
    user,
    branch,
    getPublicationsSales,
    publicationsAndSales,
    cleanPublicationsSales,
    date,
    className = undefined
}: PublicationsAndSalesDashboardProps) => {
    const toast = useToast();

    const dataNormalized: any = useMemo(() => {
        let data: any = [
            {
                name: 'Publicaciones',
                data: [],
                total: 0
            }, 
            {
                name: 'Ventas',
                data: [],
                total: 0
            }
        ];
        if(publicationsAndSales?.fetching === "loading"){
            return data = [
                {
                    name: 'Cargando',
                    data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
                    total: 0
                }, 
                {
                    name: 'Cargando',
                    data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
                    total: 0
                }
            ];
        }
        if(publicationsAndSales?.data && publicationsAndSales?.data.publications && publicationsAndSales?.data?.sales){
            data[0].data = publicationsAndSales?.data?.publications && publicationsAndSales?.data?.publications.map((item: any) => (
                item?.count
            ))
            data[1].data = publicationsAndSales?.data?.sales && publicationsAndSales?.data?.sales.map((item: any) => (
                item?.count
            ))
            data[0].total = publicationsAndSales?.data?.publications && publicationsAndSales?.data?.publications.reduce((a: any, b: any) => a + b.count, 0);
            data[1].total = publicationsAndSales?.data?.sales && publicationsAndSales?.data?.sales.reduce((a: any, b: any) => a + b.count, 0);
        }
        return data;
    }, [publicationsAndSales?.data, publicationsAndSales?.fetching]);

    useEffect(() => {
        if(publicationsAndSales?.fetching === "failure"){
            if(publicationsAndSales?.error){
                toast("Ha ocurrido un error al mostrar las publicaciones y ventas");
            }
            cleanPublicationsSales();
        }
        if(publicationsAndSales?.fetching === "success"){
            cleanPublicationsSales();
        }
    }, [publicationsAndSales?.fetching]);
    
    useEffect(() => {
        if(user && (user?.branch || branch !== "")){
            getPublicationsSales();
        }
    }, [branch]);

    return(
        <div className={`${styles.publicationsAndSales} ${className}`}>
            <p className={styles.title}>Publicaciones y ventas</p>
            <div className={styles.toolbar}>
                <div className={`${styles.item} ${styles.publications}`}>
                    <div className={styles.circle}></div>
                    <p>Publicaciones</p>
                </div>
                <div className={`${styles.item} ${styles.sales}`}>
                    <div className={styles.circle}></div>
                    <p>Ventas</p>
                </div>
            </div>
            <p className={styles.sales}>
                {
                    publicationsAndSales?.fetching === "loading"
                    ?
                        <span className={styles.value}>Cargando...</span>
                    :
                        (dataNormalized.length && (dataNormalized[0].total !== 0 || dataNormalized[1].total !== 0)) 
                        ?   <span className={styles.value}>{`${dataNormalized[1].total.toString()} ventas / ${dataNormalized[0].total.toString()} publicaciones`}</span>
                        :   <span className={styles.value}>0 ventas / 0 publicaciones</span>
                }
                {/* {
                    publicationsAndSales?.fetching === "success" &&
                    <span className={styles.message}>5% que el año anterior</span>
                } */}
            </p>
            <div className={styles.chart}>
                <Chart 
                    type="bar" 
                    series={dataNormalized} 
                    height="100%"
                    options={{
                        chart: {
                            type: 'bar',
                            toolbar: {
                                show: false
                            },
                            parentHeightOffset: 0,
                            
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                borderRadius: 4
                            },
                        },
                        dataLabels: {
                            enabled: false
                        },
                        xaxis: {
                            categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                        },
                        grid: {
                            show: false
                        },
                        fill: {
                            colors: [publicationsAndSales?.fetching === "loading" ? '#dbdfe7' : '#4874D0', '#E4E8EF'],
                            opacity: 1
                        },
                        legend: {
                            show: false
                        }
                    }}
                />
            </div>
        </div>
    )
}

export default PublicationsAndSales;